export const device_type = [
    {
        label:'控制器',
        value:1
    },
    {
        label:'音箱',
        value:2
    },
    {
        label:'空调',
        value:3
    },{
        label:'打印机',
        value:4
    },
    {
        label:'锁',
        value:5
    },
    {
        label:'智能货柜',
        value:6
    }
]